import React, { useState } from "react";
import { Button, Header, Icon, Message, Segment, Table } from "semantic-ui-react";
import { toast } from "react-toastify";
import { functionBackfillFhfaHpiDataAdmin } from "../../app/firestore/functionsService";

// Admin ops tool for the FHFA House Price Index market-trend cross-check
// (see functions/index.js "FHFA HOUSE PRICE INDEX (HPI)" section). Not
// temporary - this triggers the same logic the monthly updateFhfaHpiData
// scheduled function runs, so it's useful for the initial backfill and for
// verifying/backfilling on demand going forward.
export default function FhfaHpiAdminPanel() {
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);

  async function handleRun() {
    setRunning(true);
    setResult(null);
    try {
      const res = await functionBackfillFhfaHpiDataAdmin();
      setResult(res);
      toast.success(`FHFA HPI update complete: ${res.counts.inserted} inserted, ${res.counts.updated} updated.`);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setRunning(false);
    }
  }

  return (
    <Segment clearing>
      <Header size="huge" color="blue">
        FHFA House Price Index Data
      </Header>
      <p>
        Fetches FHFA's Expanded-Data HPI (Colorado metro areas + state fallback), normalizes it, and
        upserts it into <code>marketData/hpi_*</code>. This is the same logic the monthly{" "}
        <code>updateFhfaHpiData</code> scheduled function runs automatically - use this button to run
        the initial backfill now, or to verify/backfill on demand.
      </p>
      <Button primary loading={running} disabled={running} onClick={handleRun}>
        <Icon name="refresh" />
        Run FHFA HPI Update Now
      </Button>

      {result && (
        <div style={{ marginTop: "16px" }}>
          <Message info size="small">
            Received {result.counts.received}, kept {result.counts.filtered} (Colorado markets),
            inserted {result.counts.inserted}, updated {result.counts.updated}, skipped{" "}
            {result.counts.skipped} (other states/metros), errors {result.counts.errors}.
          </Message>
          {result.perGeography?.length > 0 && (
            <Table celled compact size="small">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Geography</Table.HeaderCell>
                  <Table.HeaderCell>Periods</Table.HeaderCell>
                  <Table.HeaderCell>Inserted</Table.HeaderCell>
                  <Table.HeaderCell>Updated</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {result.perGeography.map((g) => (
                  <Table.Row key={g.geoKey}>
                    <Table.Cell>{g.geographyName}</Table.Cell>
                    <Table.Cell>{g.periodCount}</Table.Cell>
                    <Table.Cell>{g.inserted}</Table.Cell>
                    <Table.Cell>{g.updated}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          )}
        </div>
      )}
    </Segment>
  );
}
